<!--隐私协议-->
<template>
    <div class="privacy">
        <div class="container">

            <p><strong>一、承诺内容 </strong></P>
            <p>信息真实性保证</P>
            <p><strong>本人在此承诺：</strong></P>
            <p>在平台注册及使用过程中提供的所有个人信息(姓名、年龄、性别、学历、职业、婚姻状况、联系方式、照片、个人简介等)均为真实、准确、完整，不存在任何虚假、误导、隐瞒或遗漏、完整且合法取得。所发布的相亲资料未包含任何虚假、夸大或误导性内容。</P>
            <p><strong>账号使用规范：</strong></P>
            <p>本人承诺不使用他人信息进行注册或冒充他人身份，不将本人账号出借、出租、转让给任何第三方使用。</P>
            <p>因账号共享导致的一切后果由本人承担。</P>
            <p><strong>内容合规性：</strong></P>
            <p>发布的信息不违反国家法律法规、公序良俗，不包含色情、暴力、欺诈、广告营销等内容。</P>

            <p><strong>二、法律责任 </strong></P>
            <p><strong>违约责任：</strong></P>
            <p>如违反上述承诺，本人自愿承担以下责任：</P>
            <p>如因本人违反上述承诺，导致平台或其他用户遭受任何损失的，本人愿意承担全部法律责任，包括但不限于民事赔偿责任、行政处罚责任以及刑事责任。</P>
            <p>包括但不限于经济损失、诉讼费用、律师费等。</P>
            <p>刑事风险：</P>
            <p>1.若弄虚作假行为涉嫌诈骗、伪造证件等刑事犯罪，平台有权移交司法机关处理，本人自愿接受法律制裁。</P>
            <p>如因本人违反上述承诺，导致平台遭受任可损生的亚会有权要求木人赔偿全部损失并保留追究本人法律责任的权利。</P>
            <p>如因本人违反上述承诺，导致平台被第三方索赔或遭受行政处罚的，平台有权向本人追偿全部损失。</P>

            <p><strong>三、平台权利 </strong></P>
            <p>平台有权对用户提供的信息进行审核，如发现用户提供虚假信息或违反本承诺书其他条款的，平台有权采取以下措施：</P>
            <p>要求用户限期改正;</P>
            <p>暂停或终止用户账号;</P>
            <p>删除用户发布的信息;</P>
            <p>将用户列入黑名单;</P>
            <p>追究用户的法律责任。</P>
            <p>平台有权根据法律法规的变化或平台运营的需要，对本承诺书进行修改，修改后的承诺书将在平台上公布后生效。</P>

            <p><strong>四、平台免责条款 </strong></P>
            <p>平台仅提供信息发布与交流服务不对用户资料的真实性、准确性、完整性作任何担保。</P>
            <p>因用户提供虚假信息或账号被他人使用引发的纠纷，平台不承担任何法律责任。</P>

            <p><strong>五、其他条款 </strong></P>
            <p>协议更新</P>
            <p>平台有权根据法律法规变化或运营需求修改本协议，修改后的协议将通过 APP 公告或站内信通知用户。用户继续使用平台即视为接受变更后的条款。</P>
            <p><strong>争议解决：</strong></P>
            <p>因本协议产生的争议，双方应友好协商解决;协商不成的，提交平台运营方所在地人民法院诉讼解决。</P>
            <p><strong>补充说明：</strong></P>
            <p>本协议未尽事宜，以《爱驿站用户协议》及《隐私政策》为准。</P>


            <div class="footer">
                <p><strong>江苏爱驿站信息科技有限公司</strong></p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
    <!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.privacy{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
    word-break: break-all;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
        word-break: break-all;
    }
}
</style>
<script setup lang="ts">
</script>